import React from 'react'
import classNames from 'classnames'
import { useHistory } from 'react-router-dom'

const QuestSection = ({ task }) => {
  const history = useHistory()
  const isClickable = !task.disabled

  return (
    <div
      onClick={
        isClickable
          ? task.onClick || (() => history.push(task.link))
          : undefined
      }>
      <div
        className={classNames('quest-section-card', {
          'cursor-pointer': isClickable,
        })}>
        {task.imageSrc ? (
          <img
            className='quest-important-item-image'
            src={task.imageSrc}
            alt={task.title}
            width='66'
            height='66'
            loading='lazy'
            decoding='async'
          />
        ) : (
          <div className='quest-section-icon rounded-circle d-flex align-items-center justify-content-center'>
            <div>{task.icon}</div>
          </div>
        )}
        <div className='quest-important-item-copy text-start'>
          <div className='quest-important-item-title'>{task.title}</div>
          <div className='quest-important-item-detail'>{task.text}</div>
        </div>
        {isClickable && (
          <span className='icon icon-right-arrow color-right-arrow s9 quest-important-item-arrow quest-section-arrow' />
        )}
      </div>
    </div>
  )
}

export default QuestSection
